function JobClosedIconJobDetails({ iconWidthAndHeight = "48" }) {
  return (
    <svg
      width={`${iconWidthAndHeight}`}
      height={`${iconWidthAndHeight}`}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_1106_5505"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <path d="M0 3.8147e-06H48V48H0V3.8147e-06Z" fill="white" />
      </mask>
      <g mask="url(#mask0_1106_5505)">
        <path
          d="M11.3672 1.40625V6.83578C11.3672 17.929 23.9993 24 23.9993 24C23.9993 24 36.6312 17.929 36.6312 6.83578V1.40625H11.3672Z"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.9993 24C23.9993 24 11.3672 30.071 11.3672 41.1642V46.5938H36.6313V41.1642C36.6313 30.071 23.9993 24 23.9993 24Z"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.3671 1.40625H7.9668"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M36.6309 1.40625H40.0312"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.3671 46.5938H7.9668"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M36.6309 46.5938H40.0312"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.7539 13.041H35.0976"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.0597 40.5276L11.3672 46.5938H36.4852L30.7926 40.5276C27.073 36.5639 20.7793 36.5639 17.0597 40.5276Z"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}

export default JobClosedIconJobDetails;
